<script>
import AppBar from '@components/AppBar'
import Footer from '@components/Footer'

export default {
  name: 'AppBarFooterLayout',
  components: {
    AppBar,
    Footer
  },
  computed: {
    styles () {
      return {
        content: {
          '--scale': this.scale,
          '--min-height': 'calc(100vh - (calc(150px * var(--scale)) + calc(150px * var(--scale))))'
        }
      }
    },
    scale () {
      return {
        xs: 0.5,
        sm: 0.6,
        md: 0.8,
        lg: 1,
        xl: 1
      }[this.rl.breakpoint]
    }
  }
}
</script>

<template>
  <div class="app-bar-footer-layout">
    <AppBar :scale="scale" />
    <div
      class="content"
      :style="styles.content"
    >
      <transition
        name="crossfade"
        mode="out-in"
      >
        <router-view />
      </transition>
    </div>
    <Footer :scale="scale" />
  </div>
</template>

<style lang="scss" scoped>
.app-bar-footer-layout {
  > .content {
    min-height: var(--min-height);
  }
}
.crossfade-enter-active, .crossfade-leave-active {
  transition: all .5s;
  will-change: filter, opacity, transform;
}
.crossfade-enter, .crossfade-leave-to {
  filter: blur(20px);
  opacity: 0;
  transform:  translateY(10px);
}
</style>
